/* =========================================================
    LOAD MINI CART DATA ON PAGE LOAD
========================================================= */
window.addEventListener('DOMContentLoaded', (event) => {
  getCartItem();
  var width = $(window).width(); 
  var height = $(window).height(); 
  if (!(window.location.href.indexOf("cart") > -1) && width > 767) {
    $('#Cart-Icon-Bubble').hover(function() {
      $("#js-mini-cart-visibility").removeClass("is-hide");
    });
    $('#js-mini-cart-visibility').hover(function() {
      $("#js-mini-cart-visibility").removeClass("is-hide");
    });
    $('#js-mini-cart-visibility').mouseleave(function() {
      $("#js-mini-cart-visibility").addClass("is-hide");
    });
    $('#Cart-Icon-Bubble').mouseleave(function() {
      $("#js-mini-cart-visibility").addClass("is-hide");
    });
  } else {
    $('#Cart-Icon-Bubble').click(function() {
      window.location.href = "/cart";
    })
  }
});

/* =========================================================
    CART DRAWER — FUNCTIONALITY
    Covers: remove item, item-added preview, savings calculation, Square placement
========================================================= */

/* ===== State's ===== */
var getSelectedvariant;
var getVariantIds = [];

function selectedVariant(variant) {
  getSelectedvariant = variant;
}

/* =========================================================
    REMOVE ITEM :: Collects every cart-line key that belongs to the target variant (including associated / linked / diamond lines) 
                   then zeroes them all out via /cart/update.js
========================================================= */
function removeItem(getVariantId, uniqueAssociatedKey) {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (data) {
      if (uniqueAssociatedKey == 'undefined') uniqueAssociatedKey = '';

      /* ===== Collect keys for the item being removed ===== */
      for (var i = 0; i < data.items.length; i++) {
        var item = data.items[i];
        item.properties['_associated_unique_key'] = item.properties['_associated_unique_key'] || '';
        var p   = item.properties;
        var uid = item.properties['_associated_unique_key'];
        var idkmsVariantId = 33617173905496;

        var matchesLine =
          parseInt(getVariantId) === parseInt(p._associated_link_variant_id) ||
          (getVariantId == item.variant_id && uniqueAssociatedKey == uid) ||
          getVariantId == p._sccl_associated_variant_id ||
          (getVariantId == p._complimentary_associated_variant_id && uniqueAssociatedKey == uid) ||
          (getVariantId == p._stone_associated_variant_id && uniqueAssociatedKey == uid) ||
          (getVariantId == p._associated_variant_id && uniqueAssociatedKey == uid) ||
          getVariantId == p.DiamondId ||
          (getVariantId == p._engrave_associated_var_id && uniqueAssociatedKey == uid);

        if (matchesLine) {
          getVariantIds.push(item.key);
        }
      }

      /* ===== IDKMS CHECK: using the same cart data, no extra API call ===== */
      /* Filter out the items being removed, then check what's left */
      var remainingItems = data.items.filter(function(item) {
        return getVariantIds.indexOf(item.key) === -1;
      });

      var idkmsStillNeeded = remainingItems.some(function(item) {
        return item.properties && item.properties['_is_idkms_included'] === 'true';
      });

      if (!idkmsStillNeeded) {
        /* No remaining item needs IDKMS — find the ghost and add its key to the removal batch */
        var idkmsGhost = data.items.find(function(item) {
          return String(item.variant_id) === String(idkmsVariantId);
        });
        if (idkmsGhost) {
          getVariantIds.push(idkmsGhost.key);
        }
      }

      removeAllVariantsMiniCart(getVariantId);
    },
    error: function (e) { console.log(e); }
  });
}

function removeAllVariantsMiniCart(currentVariantId) {
  var obj = {};
  $.each(getVariantIds, function (i, v) { obj[v] = 0; });
  $('#js-mini-cart-show-remove-text-' + currentVariantId).removeClass('is-hide');
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: { updates: obj },
    dataType: 'json',
    success: function (cart) {
      obj = {};
      getVariantIds = [];
      clearBespokeSelectedData(); // Clear bespoke localstorage data
      setTimeout(function () { getCartItem(); }, 1500);
    },
    error: function (e) { console.log(e); }
  });
}

/* =========================================================
    ITEM-ADDED PREVIEW
    Called after a product is successfully added to cart.
    Shows a confirmation banner with thumbnail, then transitions back to the normal cart-items view.
========================================================= */
function itemAdded(itemsCount) {
  var image = getSelectedvariant && getSelectedvariant.featured_image && getSelectedvariant.featured_image.src
    ? getSelectedvariant.featured_image.src
    : (typeof currentProductJson !== 'undefined' ? currentProductJson.featured_image : '');
   
  // Custom Combination Images for Item Added
  var toiMoiImage = $('[name="properties[_toi_moi_image]"]').val() || '';
  var engravingImage = $('[name="properties[_engraving_image]"]').val() || '';

  var customImage = '';

  // Prefer engraving image if both exist
  if (toiMoiImage.trim()) customImage = toiMoiImage.trim();
  if (engravingImage.trim()) customImage = engravingImage.trim();
  if (customImage) image = customImage;
  
  var currentId = typeof currentProductJson !== 'undefined' ? currentProductJson.id : null;

  var appendData =
    '<div class="rc-mini-cart__popover--preview-icon">' +
      '<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M15.5 0C6.94386 0 0 6.94387 0 15.5C0 23.299 5.76595 29.7608 13.2696 30.8423C13.317 30.849 13.3651 30.8462 13.4114 30.8343C13.4577 30.8223 13.5012 30.8013 13.5394 30.7726C13.5775 30.7438 13.6097 30.7078 13.6339 30.6666C13.6582 30.6254 13.6741 30.5799 13.6808 30.5325C13.6874 30.4852 13.6847 30.437 13.6727 30.3907C13.6608 30.3444 13.6398 30.301 13.611 30.2628C13.5823 30.2246 13.5463 30.1925 13.5051 30.1682C13.4639 30.1439 13.4183 30.128 13.371 30.1214C6.21669 29.0902 0.72093 22.9439 0.72093 15.5C0.72093 7.33349 7.33348 0.72093 15.5 0.72093C23.6665 0.72093 30.2791 7.33349 30.2791 15.5C30.2791 23.6666 23.6665 30.2791 15.5 30.2791C15.4104 30.2877 15.3272 30.3294 15.2666 30.396C15.206 30.4627 15.1725 30.5495 15.1725 30.6395C15.1725 30.7296 15.206 30.8164 15.2666 30.8831C15.3272 30.9497 15.4104 30.9914 15.5 31C24.0561 31 31 24.0561 31 15.5C31 6.94387 24.0561 0 15.5 0ZM23.1486 9.72129C23.0545 9.72501 22.9655 9.76545 22.9008 9.83394L13.3372 19.6566L9.00036 15.2071C8.933 15.1391 8.84144 15.1004 8.74569 15.0997C8.64993 15.0989 8.55777 15.136 8.48932 15.203C8.42087 15.27 8.38169 15.3613 8.38036 15.457C8.37903 15.5528 8.41564 15.6452 8.48219 15.714L13.0781 20.4339C13.1117 20.4686 13.152 20.4962 13.1965 20.5151C13.241 20.534 13.2889 20.5437 13.3372 20.5437C13.3856 20.5437 13.4334 20.534 13.4779 20.5151C13.5224 20.4962 13.5627 20.4686 13.5963 20.4339L23.419 10.3408C23.472 10.2898 23.5081 10.2237 23.5224 10.1515C23.5368 10.0793 23.5287 10.0045 23.4993 9.93705C23.4698 9.86959 23.4204 9.81276 23.3578 9.77419C23.2951 9.73562 23.2221 9.71716 23.1486 9.72129Z" fill="#CB9F91"/>' +
      '</svg>' +
    '</div>' +
    '<div class="rc-mini-cart__popover--preview-text">' +
      (itemsCount && itemsCount === 'multiple' ? 'Items Added' : 'Item Added') +
    '</div>' +
    '<div class="rc-mini-cart__popover--preview-thumb" id="js-mini-cart-append-image">' +
      '<img src="' + image + '" alt="">' +
    '</div>';

  // Show the preview panel
  $('.rc-mini-cart__popover').addClass('adding-to-cart');
  $('.rc-mini-cart__popover--preview').html(appendData);
  $('.rc-mini-cart__popover--preview').attr('aria-live', 'polite').attr('role', 'alert');
  $('#js-mini-cart-visibility').removeClass('is-hide');   // open popover
  $('#js-mini-cart-items').addClass('is-hide');           // hide items list
  $('#js-blank-mini-cart').addClass('is-hide');           // hide empty state
  $('#js-mini-cart-item-added').removeClass('is-hide');   // show preview
  $('#js-mini-cart-order-subtotal').removeClass('is-hide'); // keep subtotal visible
  getCartItem(true); 

  // After 4 seconds: swap back to cart items and close the popover
  function restoreCartView() {
    $('.rc-mini-cart__popover').removeClass('adding-to-cart').addClass('is-hide');
    $('#js-mini-cart-item-added').addClass('is-hide');
    $('#js-mini-cart-items').removeClass('is-hide');
    getCartItem(); 
  }
  
  /* ===== ITEM ADDED PREVIEW: SHOW FOR 4 SECONDS ===== */
  setTimeout(restoreCartView, 4000);
}

/* =========================================================
    SQUARE PLACEMENT
    Dynamically injects/refreshes the <square-placement> widget just above the "Go to bag" button.
========================================================= */
function updateSquarePlacement(total_price, skus, categories) {
  // Remove any existing Square placement to avoid duplicates
  $('.rc-mini-cart__popover--square-placement[data-page-type="cart"]').remove();

  var squarePlacement = document.createElement('square-placement');
  squarePlacement.setAttribute('data-mpid',             '1816f73a-3d89-453c-860d-c7e47a566332');
  squarePlacement.setAttribute('data-placement-id',     '4b5e0f24-aa6f-49a8-bb5f-3cb39aef3552');
  squarePlacement.setAttribute('data-page-type',        'cart');
  squarePlacement.setAttribute('data-amount',           total_price);
  squarePlacement.setAttribute('data-currency',         'USD');
  squarePlacement.setAttribute('data-consumer-locale',  'en-US');
  squarePlacement.setAttribute('data-item-skus',        skus.join(','));
  squarePlacement.setAttribute('data-item-categories',  categories.join(','));
  squarePlacement.setAttribute('data-is-eligible',      'true');
  squarePlacement.classList.add('rc-mini-cart__popover--square-placement');
  squarePlacement.style.marginLeft = '0px';

  var cartBtn = document.querySelector('.rc-mini-cart__popover--cart-btn');
  if (cartBtn) {
    cartBtn.parentNode.insertBefore(squarePlacement, cartBtn);
  }
}

/* ====== Handles (ghost / helper products) that should never appear as visible line items in the drawer ====== */
var HIDDEN_HANDLES = [
  'emerald-stone-selection','pear-stone-selection',
  'toi-et-moi-cloud-emerald-stone','toi-et-moi-cloud-pear-stone',
  'custom-stone-count','custom-stone-count-2',
  'tennis-stone-count-lab','tennis-stone-count',
  'custom-stone-count-band','complimentary-gift',
  'gift-wrap','i-dont-know-my-ring-sizer-ghost-product',
  'ccl1','ccl2','ccl3','color-dropdown',
  'ring-concierge-gift-card','soft-chain-custom-length',
  'gift-wrapping-1','vow-eng-ring-sizer','gift-wrapping',
  'add-engraving', 'locket-charms'
];

/* ========================================================= 
    GET CART ITEMS  (main render + savings + Square)
    Fetches /cart.js, builds the drawer item list, calculates compare-at savings, and injects Square.
========================================================= */
function getCartItem(silentUpdate) {
  silentUpdate = silentUpdate || false;
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (data) {
      /* ===== Cart count badge ===== */
      if (data.items.length <= 1) {
        $('#cart-item-count').text('Cart You have ' + data.items.length + ' item');
      } else {
        $('#cart-item-count').text('Cart You have ' + data.items.length + ' items');
      }

      if (data.items.length !== 0) {
        $('.rc-mini-cart__popover--items').html('');
        // $('.rc-mini-cart__popover--subtotal-amount').html('');

        var appendData   = '';
        var total_price  = '';
        var totalSavings = 0;
        var productCache = {};
        var requests     = [];
        var skus         = [];
        var categories   = [];

        for (var i = 0; i < data.items.length; i++) {
          var dataItems = data.items[i] || {};

          /* ===== Skip hidden / ghost line items ===== */
          if ( HIDDEN_HANDLES.indexOf(dataItems.handle) !== -1 || dataItems.product_type === 'Diamond') continue;

          /* ===== Field extraction ===== */
          var productName           = dataItems.product_title;
          var product_variant_title = dataItems.variant_title != null ? dataItems.variant_title : dataItems.product_title;
          var products_total_price  = data.total_price;
          var product_url           = dataItems.url;
          var productQuantitiy      = dataItems.quantity;
          var productImage          = dataItems.image;
          var uniqueAssociatedKey   = dataItems.properties ? dataItems.properties['_associated_unique_key'] : undefined;

          /* ===== Image overrides for special product IDs ===== */
          if (dataItems.product_id == 7016921235544) productImage = dataItems.properties['_toi_moi_image'];
          if (dataItems.product_id == 6644686127192) productImage = dataItems.properties['_zodiac_image'];
          if (dataItems.product_id == 7374146306136) productImage = dataItems.properties['_image'];
          if (
            dataItems.properties &&
            dataItems.properties['_engraving_image'] &&
            (typeof currentProductJson === 'undefined' || currentProductJson.id !== 8005498110040)
          ) {
            productImage = dataItems.properties['_engraving_image'];
          }

          /* ===== Variant ID — use DiamondId property when present ===== */
          var product_variant_id = (dataItems.properties && dataItems.properties.DiamondId)
            ? dataItems.properties.DiamondId
            : dataItems.variant_id;

          var productHandle = dataItems.handle;

          /* ===== Build list item HTML ===== */
          appendData +=
            '<li class="rc-mini-cart__popover--item" id="js-mini-cart-remove-item-' + product_variant_id + '">' +
              '<div class="rc-mini-cart__popover--removed is-hide" id="js-mini-cart-show-remove-text-' + product_variant_id + '">' +
                '<div class="rc-mini-cart__popover--removed-text">' + productName + ' has been removed.</div>' +
              '</div>' +
              '<div class="rc-mini-cart__popover--thumb">' +
                '<a class="rc-mini-cart-redirect" href="' + product_url + '"><img height="auto" width="auto" src="' + productImage + '" alt=""></a>' +
              '</div>' +
              '<div class="rc-mini-cart__popover--info">' +
                '<a class="rc-mini-cart-product-link" href="' + product_url + '"><h4 class="rc-mini-cart__popover--title">' + productName + '</h4></a>' +
                '<a class="rc-mini-cart-product-link" href="' + product_url + '"><p class="rc-mini-cart__popover--subtitle">' + product_variant_title + '</p></a>' +
                '<p class="rc-mini-cart__popover--subtitle">Qty: ' + productQuantitiy + '</p>' +
              '</div>' +
              '<div class="rc-mini-cart__popover--item-removed" onclick="removeItem(\'' + product_variant_id + '\',\'' + uniqueAssociatedKey + '\')">' +
                '<svg class="icon icon-close" width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M21 1L1 21M1 1L21 21" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round"></path></svg>' +
              '</div>' +
            '</li>';

          /* ===== Collect SKUs & categories for Square ===== */
          skus.push(dataItems.sku || dataItems.variant_id);
          categories.push(dataItems.product_type || '');

          /* ===== Subtotal ===== */
          total_price = parseFloat(products_total_price) / 100;
          if (total_price != null && total_price % 1 !== 0) {
            total_price = parseFloat(total_price).toLocaleString(undefined, { minimumFractionDigits: 2 });
          }

          /* ===== Queue product JSON fetch for savings (once per handle) ===== */
          if (!productCache[productHandle] && typeof hideSavingTextCartMiniCart === 'undefined') {
            productCache[productHandle] = $.getJSON('/products/' + productHandle + '.js');
            requests.push(productCache[productHandle]);
          }
        } 

        /* ===== Square Placement ===== */
        updateSquarePlacement(total_price, skus, categories);

        /* ===== Savings calculation (after all product JSONs load) ===== */
        $.when.apply($, requests).done(function () {
          /* ===== Normalise single vs. multiple $.when responses ===== */
          var responses = (
            arguments.length === 3 && arguments[1] === 'success'
          ) ? [arguments] : Array.prototype.slice.call(arguments);

          for (var r = 0; r < responses.length; r++) {
            var resp = responses[r][0];
            if (resp && resp.handle) {
              productCache[resp.handle] = resp;
            }
          }

          /* ===== Calculate per-item savings ===== */
          data.items.forEach(function (dataItems) {
            var product = productCache[dataItems.handle];
            if (!product) return;

            var variantInfo = product.variants.find(function (v) {
              return parseInt(v.id) === parseInt(dataItems.variant_id);
            });
            if (!variantInfo) return;

            var compareAt  = variantInfo.compare_at_price ? variantInfo.compare_at_price / 100 : 0;
            var unitPrice  = dataItems.price / 100;
            var qty        = dataItems.quantity;
            var expected   = compareAt > unitPrice ? compareAt * qty : unitPrice * qty;
            var actual     = dataItems.final_line_price / 100;
            var itemSaving = expected - actual;

            if (itemSaving > 0) totalSavings += itemSaving;

            /* ===== Inject savings banner (skip on /cart page) ===== */
            if (totalSavings > 0 && typeof pageType !== 'undefined' && pageType !== 'cart' && window.__rcHideSavingsText !== 'true') {
              $('.rc-mini-cart__popover--savings').remove();
              var formattedSavings = totalSavings.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
              $('.docapp-cart-with-coupon-summary').after(
                '<div class="rc-mini-cart__popover--savings" style="color: '+ window.__rcSavingsTextColor +'">' +
                  'You are saving $' + formattedSavings +
                '</div>'
              );
            }
          });
        });

        /* ===== Render ===== */
        $('.rc-mini-cart__popover--items').html(appendData);
        //$('.rc-mini-cart__popover--subtotal-amount').html('$' + total_price);

        // Only swap panels if not in preview mode
        if (!silentUpdate) {
          $('#js-mini-cart-items').removeClass('is-hide');
          $('#js-blank-mini-cart').addClass('is-hide');
          $('#js-mini-cart-item-added').addClass('is-hide');
          $('#js-mini-cart-order-subtotal').removeClass('is-hide');
        }
        $('.cart-count-dot').removeClass('is-hide');

      } else {
        /* ===== Empty cart state ===== */
        $('#js-mini-cart-items').addClass('is-hide');
        $('#js-mini-cart-item-added').addClass('is-hide');
        $('#js-blank-mini-cart').removeClass('is-hide');
        $('.cart-count-dot').addClass('is-hide');
        $('#js-mini-cart-order-subtotal').addClass('is-hide');
      }
    },
    error: function (e) { console.log(e); }
  });
}